import bankList from '../../../services/bankList.json';

export function TransactionSection({ title, data, isDestination = false }) {
  const safeValue = (value, fallback = "Não informado") => value ?? fallback;
  const formatBank = (bank) => bank ? `${bank} - ${getBankName(bank)}` : "Banco não informado";
  const formatAccount = (account, digit) => account && digit ? `${account} - ${digit}` : "Conta não informada";

  const hideTaxNumber = (taxNumber) => {
    if(taxNumber){
        let originalTaxNumber = taxNumber;
        let formattedTaxNumber;
        if(originalTaxNumber.length === 14){
            formattedTaxNumber = `** *** ${originalTaxNumber.slice(5,8)} /**** - ${originalTaxNumber.slice(-2)}`;
        } else if(originalTaxNumber.length === 11){
            formattedTaxNumber = `*** *** ${originalTaxNumber.slice(6,9)} - ${originalTaxNumber.slice(-2)}`
        }

        return formattedTaxNumber
    }
    return "CPF/CNPJ não informado"
  }

  const getBankName = (bankCode) => {
    const bank = bankList.find((item) => item.code == bankCode);
    return bank ? bank.name : '';
  };

  return (
    <div className={`transaction-section ${isDestination ? 'destination' : 'origin'}`}>
    <div className="section-header">
      <div className="section-icon">
        <i className={`icon ${isDestination ? 'icon-building' : 'icon-user'}`}></i>
      </div>
      <h3>{title}</h3>
    </div>
    <div className="section-content">
      <div className="info-item">
        <label>Nome</label>
        <p>{safeValue(data.name)}</p>
      </div>
      <div className="info-item">
        <label>CPF/CNPJ</label>
        <p>{hideTaxNumber(data.taxNumber)}</p>
      </div>
      <div className="info-item">
        <label>Instituição</label>
        <p>{formatBank(data.bank)}</p>
      </div>
      <div className="row g-2">
        <div className="col-6">
          <div className="info-item">
            <label>Agência</label>
            <p>{safeValue(data.branch)}</p>
          </div>
        </div>
        <div className="col-6">
          <div className="info-item">
            <label>Conta</label>
            <p>{formatAccount(data.account, data.digit)}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}
